// has to be `required` for ooi worker
// eslint-disable-next-line
const {component} = require('./CurrencyConverterAppConfig');

module.exports = {
  default: {
    component,
  },
};
